import React from 'react';
import { FullScreen } from './FullScreen';
import { Row, Col } from 'react-bootstrap';
import { ERROR_BOUNDARY_TITLE, ERROR_BOUNDARY_TEXT } from '../constants/errors';
import errorIcon from '../media/error.svg';


export class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	render() {
		if (this.state.hasError) {
			return (
				<FullScreen>
					<div className="error-boundary-container">
						<Row>
							<Col md="auto">
								<img
									className="error-icon"
									src={errorIcon}
									alt="Internal Server Error"
								/>
							</Col>
							<Col className="align-bottom">
								<h1 className="red-text error-boundary-container__title">
									{ERROR_BOUNDARY_TITLE}
								</h1>
								<h3>{ERROR_BOUNDARY_TEXT}</h3>
							</Col>
						</Row>
					</div>
				</FullScreen>
			);
		}

		return this.props.children;
	}
}